import React from "react";

import ScientistsWorkingInALaboratory from "../../../assets/lab-zero-vision-and-mission-australian-laboratory-sustainability.webp";

const VisionMission: React.FC = () => {
  return (
    <section className="secondary-page">
      <div className="max-w-6xl mx-auto">
        <h1>Vision & Mission</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-16">
          {/* Mission Section */}
          <div className="lg:col-span-2">
            <div className="space-y-6 l0-section-text">
              <p>We help Australian labs - wet and dry take small, achievable steps that add up to big environmental wins!</p>
              <div className="l0-section-text">
                <p>Through our easy to use certification platform, labs can:</p>
                <ul className="l0-list">
                  <li><b className="l0-emphasis">Cut energy use & lower greenhouse gas emissions</b></li>
                  <li><b className="l0-emphasis">Reduce single-use plastics</b></li>
                  <li><b className="l0-emphasis">Increase recycling rates</b></li>
                  <li><b className="l0-emphasis">Use less water</b></li>
                </ul>
              </div>
              <p>Our approach fits into busy research schedules - no extra workload, no compromise on safety.</p>
              <p>We aim to prove that research can stay safe, high-performing, and be less resource intensive.</p>
            </div>
          </div>

          <div className="lg:col-span-1 mx-auto">
            <div className="w-full max-w-sm lg:max-w-none border-4 sm:border-[6px] border-primary rounded-md overflow-hidden">
              <img src={ScientistsWorkingInALaboratory}
                alt="Scientists working in a laboratory"
                className="lg:w-full sm:w-[350px] w-[250px] h-full lg:h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

VisionMission.displayName = "VisionMission";

export default VisionMission;
